import { useEffect } from "react";
import {
  DeepMap,
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { FormValues } from ".";
import useLazyQuery from "../../../customHooks/useLazyQuery";
import Zipcode from "./zipCode";

interface Response {
  data: {
    City: string;
    State: string;
  };
  userMessage: string;
}

interface Props {
  register: any;
  setValue: any;
  watch: any;
  clearErrors: any;
  setError: any;
  errors: any;
}
const Groupstates = ({
  clearErrors,
  errors,
  register,
  setError,
  setValue,
  watch,
}: Props) => {
  const [getdata, { isLoading, data, error }] = useLazyQuery<Response>();

  useEffect(() => {
    if (data?.data) {
      setValue("employee_city", data.data.City);
      setValue("employee_state", data.data.State);
      clearErrors("employee_zip_code");
    }
  }, [data]);
  useEffect(() => {
    if (error) {
      setError("employee_zip_code", {
        type: "validate",
        message: "Zipcode is not valid",
      });
    }
  }, [error]);
  return (
    <>
      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <Zipcode
            register={register}
            setValue={setValue}
            watch={watch}
            clearErrors={clearErrors}
            setError={setError}
            errors={errors}
            getData={getdata}
            isLoading={isLoading}
            data={data}
            error={error}
          />
        </div>
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">State</span>
              {isLoading && <span className="c-input__wait">Searching...</span>}
            </div>
            <input
              type="text"
              className="c-input__input"
              {...register("employee_state")}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>

      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">City</span>
              {isLoading && <span className="c-input__wait">Searching...</span>}
            </div>
            <input
              type="text"
              className="c-input__input"
              {...register("employee_city")}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Groupstates;
